import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { ASSETS, BRAND, NAV_LINKS, whatsappHref } from "../../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-[#052e1e] text-[#f7f3e9] pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Logo + tagline */}
          <div className="md:col-span-5">
            <img
              src={ASSETS.footerCrest}
              alt="The Brook at Khanna's Farm"
              loading="lazy"
              decoding="async"
              className="w-56 object-contain"
            />
            <p className="font-body font-light text-[#f7f3e9]/70 text-sm mt-6 max-w-xs leading-relaxed">
              {BRAND.tagline}
            </p>
          </div>

          {/* Explore */}
          <div className="md:col-span-3">
            <h3 className="font-body text-[#ddb128] text-xs tracking-[0.25em] uppercase mb-5">
              Explore
            </h3>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.slice(1)}`}
                    className="font-body font-light text-[#f7f3e9]/80 text-sm hover:text-[#ddb128] transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={whatsappHref()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-reserve"
                  className="font-body font-light text-[#f7f3e9]/80 text-sm hover:text-[#ddb128] transition-colors"
                >
                  Reserve
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h3 className="font-body text-[#ddb128] text-xs tracking-[0.25em] uppercase mb-5">
              Visit &amp; Contact
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={17} className="text-[#ddb128] mt-0.5 shrink-0" />
                <span className="font-body font-light text-[#f7f3e9]/80 text-sm leading-relaxed">
                  {BRAND.address}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={17} className="text-[#ddb128] shrink-0" />
                <div className="flex flex-col">
                  <a
                    href={`tel:${BRAND.phoneDisplay.replace(/\s/g, "")}`}
                    className="font-body font-light text-[#f7f3e9]/80 text-sm hover:text-[#ddb128] transition-colors"
                  >
                    {BRAND.phoneDisplay}
                  </a>
                  <a
                    href={`tel:${BRAND.phoneDisplay2.replace(/\s/g, "")}`}
                    className="font-body font-light text-[#f7f3e9]/80 text-sm hover:text-[#ddb128] transition-colors"
                  >
                    {BRAND.phoneDisplay2}
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={17} className="text-[#ddb128] shrink-0" />
                <a
                  href={`mailto:${BRAND.email}`}
                  className="font-body font-light text-[#f7f3e9]/80 text-sm hover:text-[#ddb128] transition-colors"
                >
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram size={17} className="text-[#ddb128] shrink-0" />
                <a
                  href={BRAND.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body font-light text-[#f7f3e9]/80 text-sm hover:text-[#ddb128] transition-colors"
                >
                  {BRAND.instagramHandle}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-rule mt-16 mb-8" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-[#f7f3e9]/50 text-xs tracking-wide">
            © {new Date().getFullYear()} {BRAND.full}. All rights reserved.
          </p>
          <p className="font-script text-[#ddb128] text-2xl">
            Rooted in nature, crafted with heart.
          </p>
        </div>
      </div>
    </footer>
  );
};
